import Lozenge, { ThemeAppearance } from "@atlaskit/lozenge";

import { SupportRequestStatusCategory } from "@/libraries/bxp-web-stargate-client/src";

interface StatusLozengeProps {
    status: {
        text: string;
        category: SupportRequestStatusCategory;
    };
}

/**
 * Inline lozenge with a background color depending on its general category and text on its fine-grain status
 * @deprecated - Please use @/libraries/design/components/lozenge instead
 */
export const StatusLozenge = (props: StatusLozengeProps) => {
    const getLozengeAppearance = (category: string): ThemeAppearance => {
        switch (category) {
            case "OPEN":
                return "new";
            case "IN_PROGRESS":
                return "inprogress";
            case "DONE":
            default:
                return "success";
        }
    };

    const statusText = props.status.text;
    const appearance = getLozengeAppearance(props.status.category);

    return <Lozenge appearance={appearance}>{statusText}</Lozenge>;
};
